import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-986b7940"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-full border-t border-gray-200 bg-white px-6 py-3 hidden md:flex items-center justify-between text-sm text-gray-500" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-primary",
  "aria-label": "Novidades disponíveis"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://minhaescala.app/privacy-policy.html",
  target: "_blank",
  class: "hover:text-primary transition-colors"
}, " Privacidade ", -1))

import { useChangelog } from '@/hooks/useChangelog'
import packageJson from '../../package.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const currentYear = new Date().getFullYear()

const appVersion = packageJson.version

const { hasUnread, openPanel } = useChangelog()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("span", null, " © " + _toDisplayString(_unref(currentYear)) + " BNG Hub. Todos os direitos reservados. ", 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        "data-testid": "app-version-button",
        class: "hidden sm:inline-flex items-center gap-1.5 hover:text-primary transition-colors",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(openPanel) && _unref(openPanel)(...args)))
      }, [
        _createElementVNode("span", null, "Versão " + _toDisplayString(_unref(appVersion)), 1),
        (_unref(hasUnread))
          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _hoisted_4
    ])
  ]))
}
}

})